// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import format from 'vue-text-format'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import './main.css'
import '../src/assets/css/font.css'
import cookie from 'vue-cookie'
import {postAction, getAction} from '@/api/manage.js'
import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'
import MintUI, {Swipe, SwipeItem} from 'mint-ui'
import 'mint-ui/lib/style.css'
import Storage from 'vue-ls'
import {createPinia, PiniaVuePlugin} from 'pinia'
import utilTool from '../src/utils/tool'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import { loadSysRole } from './pages/components/loadSysRole'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCn2jsrZGPsmJ_k1gMGw_xGEX1r__7EchQ',
    libraries: 'places',
    language: 'en'
  }
})
Vue.component('GmapCluster', GmapCluster)
Vue.use(format)
Vue.use(PiniaVuePlugin)
Vue.use(VueViewer)

const pinia = createPinia()

const starage_options = {
  namespace: 'pro__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local' // 存储名称: session, local, memory
}
Vue.use(Storage, starage_options)

Vue.prototype.$cookie = cookie
Vue.prototype.$tool = utilTool
Vue.use(ElementUI, {locale})
/* let login = cookie.get('token') != null && cookie.get('token') != 'null' && cookie.get('token') != 'undefined'
console.log(login)
console.log(cookie.get('token')) */
let login = Vue.ls.get('token') != null && Vue.ls.get('token') != 'null' && Vue.ls.get(Vue.ls) != 'undefined'
console.log(login, Vue.ls.get('token'))

Vue.prototype.login = getUrlVars()['dcode'] ? false : (login || getUrlVars()['token'])
Vue.prototype.username = getUserName()
Vue.prototype.$http = axios
Vue.use(MintUI)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.directive('title', {
  inserted: (el, binding) => {
    document.title = binding.value
  }
})
var location = ''
var dsn = ''

function getUserName() {
  let userInfo = Vue.ls.get('userInfo')
  if (userInfo) {
    return userInfo.firstName + userInfo.lastName
  }
}

// 判断环境
if (window.location.origin.indexOf('manage-ui') > -1) {
  // 测试环境
  location = 'https://test-thalesmart-manage-ui2.hupofintech.com'
  dsn = 'https://84aae0b9b9d6489db29f2df40240a5f2@o991616.ingest.sentry.io/5948653'
} else if (window.location.origin.indexOf('shopvidi') > -1) {
  // 生产环境
  location = 'https://shopvidi.com'
  dsn = 'https://bdf9c35881cc44fa86f1fd3abb7a9c9c@o991616.ingest.sentry.io/5948654'
}
Sentry.init({
  Vue,
  dsn: dsn,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [location, /^\//]
    })
  ],
  trackComponents: true,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})
if (login) {
  let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
  // eslint-disable-next-line no-undef
  // mixpanel.identify(userInfo.value.id)
  // eslint-disable-next-line no-undef
  // mixpanel.people.set({$email: userInfo.value.email, $name: userInfo.value.firstName + '-' + userInfo.value.lastName})

  // TODO haoyuanw add 2021-12-14 获取facebook信息 start
  fetch('https://api64.ipify.org/?format=json')
    .then(response => response.json())
    .then(response => {
      let deviceType = navigator.userAgent // 获取userAgent信息
      const params = {}
      params.userId = userInfo.value.id
      params.clientIpAddress = response.ip
      params.clientUserAgent = deviceType
      params.fbc = document.cookie.replace(/(?:(?:^|.*;\s*)_fbc\s*\=\s*([^;]*).*$)|^.*$/, '$1')
      params.fbp = document.cookie.replace(/(?:(?:^|.*;\s*)_fbp\s*\=\s*([^;]*).*$)|^.*$/, '$1')
      postAction('/facebook/client', params)
    })
  // TODO haoyuanw add 2021-12-14 获取facebook信息 end
  /* getAction('/sys/check-token',{}).then(res=>{

  }) */
}

Vue.config.productionTip = false
Vue.prototype.$tokenUrl = tokenUrl
Vue.prototype.$getUrlVars = getUrlVars

function tokenUrl(url, status) {
  let _url = url
  if (login) {
    _url += status ? `?token=${Vue.ls.get('token')}` : `&token=${Vue.ls.get('token')}`
  }
  return _url
}

let show = getUrlVars()['showlogin']
localStorage.setItem('show', show)
Vue.prototype.isCreateMarketing = true
Vue.prototype.login = getUrlVars()['dcode'] ? false : (login || getUrlVars()['token'])
Vue.prototype.$http = axios
Vue.config.productionTip = false

function getUrlVars() {
  var vars = {}
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value.split('#')[0]
  })
  return vars
}

function getEnvUrl() {
  let href = window.location.href
  let url = window.location.host
  if (href.indexOf('test') >= 0) {
    url = 'https://test-thalesmart-manage-ui.hupofintech.com'
    return url
  }
  if (href.indexOf('localhost') >= 0) {
    url = 'http://localhost:3000'
    return url
  }
  if (href.indexOf('shopvidi') >= 0) {
    url = 'https://p.shopvidi.com'
    return url
  }
}
Vue.prototype.isPartner = isPartnerFuntion()
function isPartnerFuntion() {
  return window.location.origin.indexOf('partner.shopvidi.com') > -1
}
function checkBrandReview(fullPath) {
  getAction('/register/supplier/replenish').then(response => {
    if (response.success) {
      if (response.result) {
        // 如果是false的话就直接进入brand后台
        if (!response.result.supplierStep) {
          Vue.prototype.isCheckBrandReview = true
          if (fullPath) {
            router.push(fullPath)
          } else {
            loadSysRoleFuntion()
          }
        } else {
          // 如果是true的话，看状态
          const params = {}
          if (response.result.supplierReviewStatus === 2) {
            params.result = 'declined'
          } else if (response.result.supplierReviewStatus === 1) {
            params.result = 'approved'
          } else if (response.result.supplierReviewStatus === 0) {
            params.result = 'inReview'
          } else {
            params.result = 'profile'
          }
          router.push({path: '/brand-review', query: params})
        }
      }
    } else {
      this.$message.warning(response.message)
    }
  })
}
function loadSysRoleFuntion() {
  loadSysRole(response => {
    const menuList = response
    let menu = menuList[0]
    if (menuList[0].childrenList && menuList[0].childrenList.length > 0) {
      menu = menuList[0].childrenList[0]
    }
    router.push('/menu/' + menu.key)
  })
}

router.beforeEach((to, from, next) => {
  // 如果跳转到登录页 则不需要验证 token是否有效  本应该放在else里面的 menu 但是菜单会反复选中效果不好
  // menu 放到了else中 经测试未发现问题
  if (to.name === 'home-page') {
    // sv-1.4.29 wpp 兼容，如果是访问的首页，那么判断域名，如果是brand重定向到login页面
    if (isPartnerFuntion()) {
      next()
    } else {
      // 如果是brand 要判断是否登录，登录就查看权限，不登录重定向到登录页面
      if (Vue.prototype.login) {
        // TODO 2.2.8这里要判断供应商是否审核通过
        checkBrandReview()
      } else {
        next('/login')
      }
    }
  } else if (to.name === 'login' || to.name === 'register' || to.name === 'vilocal-img-review' || to.name === 'forget') {
    next()
  } else {
    // 访问其他路径
    if (Vue.prototype.login) {
      // 如果是brand端的menu下的
      if (to.name === 'menu') {
        // 那么判断域名 partner 就返回首页不让进brand里面的东西
        if (isPartnerFuntion()) {
          // 如果进入系统内部，再判断是不是 business和采购单
          if (to.path === '/menu/business-info' || to.path.indexOf('procurement') > -1) {
            next()
          } else {
            // 如果不是就会跳到之前的
            next(from.path)
          }
        } else {
          // 如果检查过一次状态，那么不刷新的时候不会在检查
          if (!Vue.prototype.isCheckBrandReview) {
            checkBrandReview(to.fullPath)
          }
          // 如果不是partner 随便往里进
          // DEMO角色，跳转除了Explore和Account Setting 都重定向到explore
          let userInfo = Vue.ls.get('userInfo')
          if (userInfo) {
            if (userInfo.model === '100') {
              let menuList = ['/menu/Explore', '/menu/business-info']
              if (menuList.includes(to.path)) {
                next()
              } else {
                next('/menu/Explore')
              }
              return
            } else {
              // 2.2.9 更改
              if (from.path === '/menu/create-store-based-marketing' && Vue.prototype.isCreateMarketing) {
                const answer = window.confirm('当前页面数据未保存，确定要离开？')
                if (answer) {
                  next()
                }
              } else {
                next()
              }
            }
          }
          // next()
        }
      }
      if (to.name === 'review') {
        if (isPartnerFuntion()) {
          next()
        } else {
          // 如果访问review 但是不是partner 就返回到之前的页面
          next(from.path)
        }
      }
      if (to.name === 'brand-review') {
        if (isPartnerFuntion()) {
          next(from.path)
        } else {
          if (!Vue.prototype.isCheckBrandReview) {
            checkBrandReview()
          }
          next()
        }
      }
    } else {
      // 未登录情况下 如果是parterner 直接跳转首页
      if (isPartnerFuntion()) {
        next('/')
      } else {
        // 如果是brand 跳转登录页
        next('/login')
      }
    }
  }
})
Vue.prototype.axios = axios
// add by cpgu 2021/10/16 begin
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
// end by cpgu
// haoyuanw add 2021-10-21 begin

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  pinia,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js